module.exports = __webpack_public_path__ + "static/media/image62.8ea4a8ae.png";